import { createAction } from '@reduxjs/toolkit';

export const templateActionType = {
  ADD_RECENT_BACKGROUND: 'recentBackgroundDict/addRecentBackground',
  CHANGE_BACKGROUND_STEP: 'ui/changeBackgroundStep',
  CHANGE_TEMP_RECENT_BACKGROUND: 'ui/changeTempRecentBackground',
  SAVE_CURRENT_ACTIVE_COMMON_TEMPLATE: 'template/saveCurrentActiveCommonTemplate',
  CLEAR_CURRENT_ACTIVE_COMMON_TEMPLATE: 'template/clearCurrentActiveCommonTemplate',
  SELECT_TEMPLATE: 'template/selectTemplate',
};

export const initializeCategoryDict = createAction('template/initializeCategoryDict');

export const initializeCommonTemplateDict = createAction('template/initializeCommonTemplateDict');

export const initializeSpecialTemplateDict = createAction('template/initializeSpecialTemplateDict');

export const selectCategory = createAction('template/selectCategory', (imprintAreaKey, categoryId) => {
  return { payload: { imprintAreaKey, categoryId } };
});

export const selectTemplate = createAction(
  templateActionType.SELECT_TEMPLATE,
  (imprintAreaKey, categoryId, templateId) => {
    return { payload: { imprintAreaKey, categoryId, templateId } };
  }
);

export const saveCurrentActiveCommonTemplate = createAction(
  templateActionType.SAVE_CURRENT_ACTIVE_COMMON_TEMPLATE,
  (template) => {
    return { payload: { ...template } };
  }
);

export const clearCurrentActiveCommonTemplate = createAction(templateActionType.CLEAR_CURRENT_ACTIVE_COMMON_TEMPLATE);

export const initializeBackgroundDesignPanelShownFlags = createAction(
  'template/initializeBackgroundDesignPanelShownFlags',
  (imprintAreaKeys) => {
    return { payload: { imprintAreaKeys } };
  }
);

export const setBackgroundDesignPanelShownFlag = createAction(
  'template/setBackgroundDesignPanelShownFlag',
  (imprintAreaKey) => {
    return { payload: { imprintAreaKey } };
  }
);
export const changeBackgroundStep = createAction(templateActionType.CHANGE_BACKGROUND_STEP);
export const addRecentBackground = createAction(templateActionType.ADD_RECENT_BACKGROUND);
export const changeTempRecentBackground = createAction(templateActionType.CHANGE_TEMP_RECENT_BACKGROUND);
